import { Row } from 'app/design/primitives/box';
import { Checkbox } from 'app/design/primitives/checkbox';
import { Link } from 'app/design/primitives/link';
import { OrderedList } from 'app/design/primitives/ordered';
import { Text } from 'app/design/primitives/text';
import { preparePolicyUrl } from 'app/lib/text';
import type { CreateGuidelinesDTO } from 'app/network/user';
import type { User } from 'app/types/user';
import type { TFunction } from 'i18next';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { Trans } from 'react-i18next';

export function GuidelinesAgreementBody({
  bullets,
  control,
  i18nLanguage,
  t,
  user,
}: {
  bullets: string[];
  control: Control<CreateGuidelinesDTO>;
  i18nLanguage: string;
  t: TFunction;
  user?: User | null;
}) {
  return (
    <>
      <OrderedList>
        {bullets.map((bullet) => (
          <OrderedList.Point flex={1} key={bullet}>
            <Trans components={{ strong: <Text fontWeight="700" /> }} i18nKey={bullet} ns="guidelines" />
          </OrderedList.Point>
        ))}
      </OrderedList>

      <Row alignItems="center" marginTop="spacing.general.x4">
        <Controller
          {...{ control }}
          name="acceptGuidelines"
          render={({ field }) => (
            <Checkbox
              checked={field.value}
              onPress={() => field.onChange(!field.value)}
              testID="guidelines-accept-guidelines"
            />
          )}
        />

        <Text flex={1} marginStart="spacing.general.x4" variant="bodyBase">
          {t('guidelinesCheckboxText')}
        </Text>
      </Row>

      <Row alignItems="center" marginTop="spacing.general.x4">
        <Controller
          {...{ control }}
          name="acceptConditions"
          render={({ field }) => (
            <Checkbox
              checked={field.value}
              onPress={() => field.onChange(!field.value)}
              testID="guidelines-accept-conditions"
            />
          )}
        />

        <Text flex={1} marginStart="spacing.general.x4" variant="bodyBase">
          <Trans
            components={{
              Link1: (
                <Link
                  href={preparePolicyUrl(t('link1', { ns: 'privacy' }), i18nLanguage, user ?? undefined)}
                  color="text.interactive"
                />
              ),
              Link2: (
                <Link
                  href={preparePolicyUrl(t('link2', { ns: 'privacy' }), i18nLanguage, user ?? undefined)}
                  color="text.interactive"
                />
              ),
            }}
            i18nKey="conditionsCheckboxText"
            ns="guidelines"
          />
        </Text>
      </Row>
    </>
  );
}
